import { createSelector } from '@reduxjs/toolkit'

import { ManychatLegalEntity } from 'common/billing/constants/AccountBillingInfo'
import { getManychatLegalEntity } from 'common/billing/entities/billingInfo/selectors'
import { getAccountFlags } from 'common/core/selectors/appSelectors'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'

export const getAllowInAppUpgrade = createSelector(
  getAccountFlags,
  getManychatLegalEntity,
  (flags, legalEntity): boolean =>
    Boolean(flags?.[AccountFlag.ENABLE_IN_APP_CHECKOUT_BRAZIL_REGFLOW]) &&
    legalEntity === ManychatLegalEntity.Brazil,
)
